// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__i9n_v","image":"styles_image__t9KIv"};